import React, { useEffect, memo } from 'react';
import { Alert, Container, Text } from '@groupelacentrale/contact-storybook';
import './DepositSidebar.scss';
import { initAppNexus } from 'utils/appNexus';

const DepositSidebar = memo(() => {
  useEffect(() => {
    initAppNexus();
  }, []);

  return (
    <Container shadowed paddings="mediumP" className="deposit-sidebar" backgroundColor="bgWhite">
      <div className="ad-bloc">
        <div data-pub-appnexus="Pave"></div>
      </div>
      <Alert>
        <span className="alert-text">
          <Text color="primary" size="large" weight="bold">
            Besoin d&apos;aide ?
          </Text>
          <Text color="primary">
            Nos conseillers vous répondent au <b className="phone-number">01 77 49 01 86</b>
            &nbsp;(prix d&apos;un appel local depuis un poste fixe) du <b>lundi au vendredi de 9h à 18h</b>
          </Text>
        </span>
      </Alert>
    </Container>
  );
});

DepositSidebar.displayName = 'DepositSidebar';

export { DepositSidebar };
